import { Typography } from '@telavita-core/react-design-kit'
import * as S from './styles'
import React, { FC, ReactNode } from 'react'

interface RadioButtonErrorWrapperProps {
  errorMessage: string
  children: ReactNode
}

export const RadioButtonErrorWrapper: FC<RadioButtonErrorWrapperProps> = ({
  errorMessage,
  children,
}) => {
  const hasErrorMessage = Boolean(errorMessage)
  return (
    <S.RadioButtonErrorWrapperContainer>
      {children}
      {hasErrorMessage && (
        <S.ErrorMessageWrapper>
          <Typography variant='content3'>{errorMessage}</Typography>
        </S.ErrorMessageWrapper>
      )}
    </S.RadioButtonErrorWrapperContainer>
  )
}
